import type {Margin} from '@yandex-delivery/blocks'
import React from 'react'

import type {TariffsZone} from '../../../../api'
import {TariffsMap} from '../../../../components/TariffsMap'
import {useMapPoints} from './hooks'
import {marker} from './utils'

type Props = {
  zones: TariffsZone[]
  country: string
  margin?: Margin
  withZoomControls?: boolean
}

export function Map({zones, country, margin, withZoomControls}: Props) {
  const points = useMapPoints(zones, country)

  return <TariffsMap margin={margin} marker={marker} points={points} withZoomControls={withZoomControls} />
}
